import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IBKRChatView } from "../ibkr_fast/IBKRChat";
import { newId, useIBKRChatStore } from "../ibkr_fast/store";
import { C, FONT } from "../ibkr_fast/ui";

// IBKR chat as a full-screen mobile page: a new, independent chat every time
// the page is opened, dropped when it is left
export const MobileIBKRChat = () => {
  const navigate = useNavigate();
  const [chatId] = useState(() => `ibkr_chat_mobile_${newId()}`);
  // ?message=AAPL (IB Fast from ClearCross) is sent once on open, like the desktop window's params.message
  const [searchParams] = useSearchParams();
  const initialMessage = searchParams.get("message") || undefined;
  useEffect(() => () => useIBKRChatStore.getState().dropChat(chatId), [chatId]);

  return (
    <div style={{ height: "100dvh", display: "flex", flexDirection: "column", background: "#fff", fontFamily: FONT }}>
      <div style={{ flex: "none", height: 40, display: "flex", alignItems: "center", gap: 10, padding: "0 10px", background: C.headerBg, borderBottom: `1px solid ${C.divider}`, color: "#555", fontSize: 13 }}>
        <button onClick={() => navigate("/mobile")} aria-label="Back to the mobile menu"
          style={{ height: 30, padding: "0 10px", background: "#fff", border: `1px solid ${C.border}`, fontFamily: "inherit", fontSize: 13 }}>
          ← Menu
        </button>
        <span>IBKR chat</span>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <IBKRChatView chatId={chatId} isMobile initialMessage={initialMessage} />
      </div>
    </div>
  );
};
